const menu = () => {
    return {
        open: false,
        height: 0,
        closeNav () {
            this.open = false
            this.height = 0
        },
        toggleNav () {
            if (this.open)
                return this.closeNav()

            this.open = true
            // this.height = this.$refs.menu.scrollHeight
        }
    }
}

const copyright = () => {
    let year = (new Date()).getFullYear()
    return {
        year,
        years: (year === 2020) ? '2020' : '2020-' + year,
    }
}

const discord = () => {
    return {
        count: 0,
        ping () {
            axios.get('https://discord.com/api/guilds/' + global.discord.id + '/widget.json')
                .then(res => {
                    this.count = res.data.presence_count
                })
        }
    }
}

const minecraft = () => {
    return {
        count: 0,
        copied: false,
        ping () {
            let copy = new ClipboardJS('.server.server-mc')
            axios.get('https://api.mcsrvstat.us/2/' + global.ip)
                .then(res => {
                    if (res.data.online) {
                        this.count = res.data.players.online
                    } else {
                        this.count = 'Error'
                    	console.log(res)
                    }
                })
        },
        copy () {
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 5000)
        }
    }
}

const vote = () => {
	return {
		links: global.vote.links,
		rewards: global.vote.rewards
	}
}
